
import { mapGetters } from 'vuex'
import html2canvas from 'html2canvas'
import { copyToClip } from '~/utils/index'
export default {
	data() {
		return {
			imGroupId: null,
			activeTab: 'detail', // 默认选中"详细规划"
			gameList: [],
			// 当前页码
			currentPage: 1,
			pageSize: 10,
			totalCount: 0,
			hasMore: true,
			loading: false,
			dialogShow: false,
			promoCode: '',
			promoCodeError: '',
			userIdentity: '',
			customerId: '',
			myInfo: {},
			qrCodeUrl: '',
			bottomDialogShow: false,
			shareType: 0,
			inviteUser: {},
			noticeDialogShow: false
		}
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			userAccount: 'user/userAccount',
			defaultAvatar: 'user/defaultAvatar'
		}),
		// 用户信息对象，兼容不同的属性名
		userInfo() {
			return this.userinfo || {}
		}
	},
	mounted() {
		// 确保获取用户信息
		if (!this.userinfo || !this.userinfo.id) {
			this.$store.dispatch('user/UserGetInfo')
		}

		this.getGameListInfo()
		this.$api.getUserIdentity().then(res => {
			if (res.success) {
				this.userIdentity = res.data.idenType
				this.customerId = res.data.customerId
				if (this.userIdentity != 'UNKNOWN') {
					this.getInfo()
					this.getAllApple()
				}
			}else{
				if(res.code === 'NOT_LOGGED_IN'){
					this.$router.push('/')
				}
			}
			
		})
	},
	methods: {
		gotoChat() {
			this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
			this.$store.commit('ry/SET_GLOBAL_SHOW_CHAT', true)
			this.$store.dispatch('ry/join', { targetId: this.customerId, conversationType: 1 })
		},
		joinGroup() {
			this.dialogShow = true
		},
		switchTab(tab) {
			this.activeTab = tab
		},
		getAllApple() {
			this.$api.getApply().then(res => {
				if (res.success) {
					console.log(res)
					this.inviteUser = res.data
				}
			})
		},
		// 获取状态样式类
		getStatusClass(status) {
			const statusMap = {
				0: 'status_pending', // 待处理
				1: 'status_approved', // 已通过
				2: 'status_rejected' // 已拒绝
			}
			return statusMap[status] || 'status_pending'
		},
		// 获取状态文本
		getStatusText(status) {
			const statusMap = {
				0: '待处理',
				1: '已通过',
				2: '已拒绝'
			}
			return statusMap[status] || '待处理'
		},
		getInfo() {
			this.$api.getMyPopularizer().then(res => {
				if (res.success) {
					this.myInfo = res.data
					this.qrCodeUrl = `${window.location.origin}/login?inviteCode=${this.myInfo.inviteCode}`
				}
			})
		},
		// ============ 输入验证函数 ============
		/**
		 * 按键输入验证 - 只允许数字和字母字符
		 * @param {KeyboardEvent} event - 键盘事件对象
		 */
		onKeypress(event) {
			const char = String.fromCharCode(event.which)
			// 如果输入的不是数字或字母，阻止默认行为
			if (!/[0-9a-zA-Z]/.test(char)) {
				event.preventDefault()
			}
		},
		copyShareLink() {
			if (this.qrCodeUrl) {
				copyToClip(this.qrCodeUrl, '分享链接已复制')
			} else {
				this.$message.success('链接生成中，请稍后重试')
			}
		},
		/**
		 * 输入内容过滤 - 移除所有非数字和字母字符
		 * @param {InputEvent} event - 输入事件对象
		 */
		onInput(event) {
			const value = event.target.value
			// 使用正则表达式过滤掉所有非数字和字母字符
			const alphanumericValue = value.replace(/[^0-9a-zA-Z]/g, '')
			this.promoCode = alphanumericValue
		},
		// 假如推广小组
		async submitGroup() {
			const result = await this.$api.joinGroup({
				inviteCode: this.promoCode
			})
			if (result.success) {
				this.dialogShow = false
				this.$message.success('操作成功')
			} else {
				this.promoCodeError = true
				this.promoCodeText = result.info
			}
		},
		agreeGroup() {
			this.$api
				.agreeJoinGroup({
					pass: true,
					userId: this.inviteUser.userId
				})
				.then(res => {
					if (res.success) {
						this.noticeDialogShow = false
						this.getAllApple()
						this.$message.success('操作成功')
					} else {
						this.$message.error(res.info)
					}
				})
		},
		disagreeGroup() {
			this.$api
				.agreeJoinGroup({
					pass: false,
					userId: this.inviteUser.userId
				})
				.then(res => {
					if (res.success) {
						this.noticeDialogShow = false
						this.getAllApple()
						this.$message.success('操作成功')
					} else {
						this.$message.error(res.info)
					}
				})
		},
		/**
		 * 获取游戏列表
		 * @param {boolean} isLoadMore 是否为加载更多操作
		 */
		getGameListInfo(isLoadMore = false) {
			// 如果正在加载或没有更多数据，则不继续请求
			if (this.loading || (!this.hasMore && isLoadMore)) {
				return
			}
			this.loading = true
			this.$api
				.getGameList({
					action: {},
					order: 'DESC',
					page: isLoadMore ? this.currentPage : 1,
					pageSize: this.pageSize,
					sort: 'create_time'
				})
				.then(res => {
					if (res.success) {
						const newData = res.data.records || []
						this.totalCount = res.data.total || 0

						if (isLoadMore) {
							// 加载更多：追加数据
							this.gameList = [...this.gameList, ...newData]
						} else {
							// 首次加载：替换数据
							this.gameList = newData
							this.currentPage = 1
						}

						// 判断是否还有更多数据
						this.hasMore = this.gameList.length < this.totalCount

						// 如果是加载更多，页码增加
						if (isLoadMore && newData.length > 0) {
							this.currentPage++
						}
					}
				})
				.catch(error => {
					this.$toast.error('获取数据失败，请重试')
				})
				.finally(() => {
					this.loading = false
				})
		},
		loadMore() {
			if (!this.loading && this.hasMore) {
				this.getGameListInfo(true)
			}
		},
		openShare(type) {
			if (type == 0) {
				this.shareType = 0
			} else {
				this.shareType = 1
			}
			this.bottomDialogShow = true
		},
		// 保存分享图片
		async saveShareImage() {
			const elementClass = this.shareType === 0 ? 'overlay_my_box' : 'overlay_group_box'
			const node = document.querySelector(`.${elementClass} .box_content`)
			this.exportToImage(node, '盼之代售分享海报')
		},
		async exportToImage(exportContent, title) {
			if (!exportContent) {
				this.$message.warning('未找到要导出的内容')
				return
			}

			try {
				// 显示加载状态
				const loading = this.$loading({
					lock: true,
					text: '正在生成图片...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				})

				let canvas = null
				let success = false

				// 方案1: 使用 modern-screenshot (推荐)
				try {
					const { domToCanvas } = await import('modern-screenshot')
					canvas = await domToCanvas(exportContent, {
						backgroundColor: '#ffffff',
						scale: 2, // 提高清晰度
						quality: 0.95,
						style: {
							transform: 'scale(1)',
							transformOrigin: 'top left'
						}
					})
					success = true
					console.log('使用 modern-screenshot 成功')
				} catch (error) {
					console.warn('modern-screenshot 失败:', error)
				}

				// 方案2: 使用 dom-to-image 作为备选
				if (!success) {
					try {
						const domtoimage = await import('dom-to-image')
						const dataUrl = await domtoimage.toPng(exportContent, {
							bgcolor: '#ffffff',
							quality: 0.95,
							style: {
								transform: 'scale(2)',
								transformOrigin: 'top left'
							},
							width: exportContent.offsetWidth * 2,
							height: exportContent.offsetHeight * 2
						})

						// 创建 canvas
						canvas = document.createElement('canvas')
						const ctx = canvas.getContext('2d')
						const img = new Image()

						await new Promise((resolve, reject) => {
							img.onload = () => {
								canvas.width = img.width
								canvas.height = img.height
								ctx.drawImage(img, 0, 0)
								resolve()
							}
							img.onerror = reject
							img.src = dataUrl
						})

						success = true
						console.log('使用 dom-to-image 成功')
					} catch (error) {
						console.warn('dom-to-image 失败:', error)
					}
				}

				// 方案3: 使用 html2canvas 作为最后备选
				if (!success) {
					try {
						const html2canvas = await import('html2canvas')
						canvas = await html2canvas.default(exportContent, {
							backgroundColor: '#ffffff',
							scale: 2,
							useCORS: true,
							allowTaint: true,
							logging: false,
							imageTimeout: 15000
						})
						success = true
					} catch (error) {
						console.error('html2canvas 也失败了:', error)
					}
				}

				loading.close()

				if (!success || !canvas) {
					this.$message.error('图片生成失败，请重试')
					return
				}

				// 下载图片
				this.downloadCanvasAsImage(canvas, title)
			} catch (error) {
				this.$message.error('图片生成失败: ' + error.message)
			}
		},

		// 下载 canvas 为图片
		downloadCanvasAsImage(canvas, title) {
			try {
				const link = document.createElement('a')
				link.download = `${title}_${new Date().getTime()}.png`
				link.href = canvas.toDataURL('image/png', 0.95)
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			} catch (error) {
				console.error('下载图片失败:', error)
				// 备选方案：在新窗口打开图片
				const newWindow = window.open()
				newWindow.document.write(`<img src="${canvas.toDataURL('image/png', 0.95)}" style="max-width:100%;"/>`)
			}
		}
	}
}
